<template>
    <div>
        <button
            :disabled="rowsAreEmpty"
            class="btn btn-primary btn-sm mr-2"
            @click="exportToCsv">
            <i class="fa fa-download"></i> CSV
        </button>
        <button
            :disabled="rowsAreEmpty"
            class="btn btn-primary btn-sm"
            @click="exportToXlsx">
            <i class="fa fa-download"></i> Excel
        </button>
        <button
            :disabled="rowsAreEmpty"
            class="btn btn-primary btn-sm ml-2"
            @click="exportToPdf">
            <i class="fa fa-download"></i> PDF
        </button>
    </div>
</template>

<script>
    import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
    import {downloadJsonAsPdf} from '@/helpers/js-pdf';
    export default {
        name: "export-actions",
        props: {
            rows: {
                type: Array,
                required: true
            },
            onClickExportButton: {
                type: Function,
                required: false
            }
        },
        computed: {
            rowsAreEmpty() {
               return this.rows.length < 1;
            }
        },
        methods: {
            async exportToXlsx() {
                if(typeof this.onClickExportButton === 'function') {
                    let rows = await this.onClickExportButton();
                    downloadJsonAsXlsx(rows);
                } else {
                    downloadJsonAsXlsx(this.rows);
                }
            },
            async exportToCsv() {
                if(typeof this.onClickExportButton === 'function') {
                    let rows = await this.onClickExportButton();
                    downloadJsonAsCsv(rows);
                } else {
                    downloadJsonAsCsv(this.rows);
                }
            },
            async exportToPdf() {
                if(typeof this.onClickExportButton === 'function') {
                    let rows = await this.onClickExportButton();
                    downloadJsonAsPdf(rows);
                } else {
                    downloadJsonAsPdf(this.rows);
                }
            },
        }
    }
</script>

<style scoped>

</style>






